import { referencedEntities } from "../facets/fields.js";
export const supportStatus = (raw, config) => {
  const query = raw;
  // which entities are present in the query
  const queryEntities = referencedEntities(query);
  const populatedEntities = config.populatedEntities || [];
  const notPopulated = queryEntities.filter(
    (e) => !populatedEntities.includes(e),
  );
  if (notPopulated.length === 0) {
    return {
      configured: true,
      populated: true,
    };
  }
  const diagnostics = notPopulated.map((e) => {
    const cannedDiagnosis = (config.entityDiagnostics || {})[e];
    return (
      cannedDiagnosis || { entity: e, populated: false, providable: false }
    ); // if it is not canned, it can only be because the entity is not provided by any of the configured integrations
  });
  return {
    configured: diagnostics.every(
      (d) =>
        d.providedByConfiguredIntegration ||
        d.providedByConfiguredIntegrationRole,
    ),
    populated: false,
  };
};
